export default "__VITE_ASSET__eLaqqQ_b__"